import React from "react";
import Layout from "./Layout";

function Credits() {
  return (
    <div className="leave-top_margin">
      <Layout>
        <div className="streamer_header">
          <h1>
            <b className="highlighted">CREDITS</b>
          </h1>
        </div>
        <div className="streamer_body">
          <div className="table_body credit-body">
            <h2 className="highlighted"> Streamers credits : </h2>
            <p>
              <b className="highlighted">Teepee :</b>{" "}
              https://www.twitch.tv/teepee{" "}
            </p>
            <p>
              <b className="highlighted">DanucD :</b>{" "}
              https://www.twitch.tv/danucd{" "}
            </p>
            <p>
              {" "}
              <b className="highlighted">Lm_Ripper :</b>{" "}
              https://www.twitch.tv/lm_ripper
            </p>
            <p>
              <b className="highlighted">Triceppps : </b>
              https://www.twitch.tv/triceppps{" "}
            </p>
            <p>
              <b className="highlighted">Nitemare_AT :</b>{" "}
              https://www.twitch.tv/nitemare_at{" "}
            </p>
          </div>
          <div className="table_body credit-body">
            <h2 className="highlighted"> 3D & 2D assets credits :</h2>
            <p>https://www.videvo.net/video/flying-over-bangkok/456585/ </p>
            <p>
              https://sketchfab.com/3d-models/combat-helicoptermotion-ba18b2d9f8824d3580e097ad6756308a
            </p>
            <p>https://unsplash.com/photos/0zeb4q6odlE</p>
            <p> https://www.youtube.com/watch?v=-5DbUCMINV4 </p>
            <p>https://unsplash.com/fr/photos/oPrXf-0Nf9Q</p>
          </div>
          <div className="table_body credit-body">
            <h2 className="highlighted">AUDIO :</h2>
            <p>https://youtu.be/oLhq1PFj5P8</p>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default Credits;
